import { useQuery } from '@tanstack/react-query';

const DEFAULT_RUNTIME_QUERY_OPTIONS = {
  staleTime: 30 * 1000,
  gcTime: 5 * 60 * 1000,
  refetchOnWindowFocus: false,
  refetchOnReconnect: true,
  retry: 1,
};

export const useRuntimeQuery = ({ queryKey, queryFn, enabled = true, ...options }) => {
  return useQuery({
    queryKey,
    queryFn,
    enabled,
    ...DEFAULT_RUNTIME_QUERY_OPTIONS,
    ...options,
  });
};

export default useRuntimeQuery;